module.exports = __webpack_public_path__ + "img/no_address.3ba31b48.svg";